var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"check-users-item-operation",style:(_vm.itemStyle),on:{"click":_vm.addMember}},[_c('span',{staticClass:"operation"},[_vm._v("+")]),_vm._v(" "),_c('span',[_vm._v("添加")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e28be826","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/im/team/CheckUserItemAdd.vue
// module id = null
// module chunks = 